import React, { FC, useMemo } from "react";
import { ResourceTypeLink } from "@evergis/api";
import { useTranslation } from "react-i18next";

import { TextBlock } from "../TopBar/styled";
import { useSelectedResources } from "../../hooks/useSelectedResources";
import { declension } from "../../../../utils/declension";

interface SelectedInfoProps {
  type: ResourceTypeLink;
}

export const SelectedInfo: FC<SelectedInfoProps> = ({ type }) => {
  const { t } = useTranslation("catalog");
  const [selected] = useSelectedResources();

  const selectedText = useMemo(() => {
    const selectedCardsCount = selected.length;

    switch (type) {
      case ResourceTypeLink.Project:
        return `${declension(
          t("chosen1"),
          t("chosen3"),
          t("chosen3"),
          selectedCardsCount,
        )} ${selectedCardsCount} ${declension(t("map1"), t("map2"), t("map3"), selectedCardsCount)}`;
      case ResourceTypeLink.Layer:
        return `${declension(
          t("chosen2"),
          t("chosen3"),
          t("chosen3"),
          selectedCardsCount,
        )} ${selectedCardsCount} ${declension(t("layer1"), t("layer2"), t("layer3"), selectedCardsCount)}`;
      case ResourceTypeLink.Table:
        return `${declension(
          t("chosen2"),
          t("chosen3"),
          t("chosen3"),
          selectedCardsCount,
        )} ${selectedCardsCount} ${declension(t("table1"), t("table2"), t("table3"), selectedCardsCount)}`;
      default:
        return null;
    }
  }, [selected, type, t]);

  return <TextBlock>{selectedText}</TextBlock>;
};
